export enum CHECKOUTCOM_CARD_FORM_TRANSITIONS {
  ERROR = 'ERROR',
  SUBMIT_CARD = 'SUBMIT_CARD',
  CREATE_PAYMENT_WITH_3DS = 'CREATE_PAYMENT_WITH_3DS',
  RESET = 'RESET',
  VALIDATE_3DS = 'VALIDATE_3DS',
  // Flow-based transitions (new)
  FLOW_MOUNTED = 'FLOW_MOUNTED',
  FLOW_PAYMENT_COMPLETED = 'FLOW_PAYMENT_COMPLETED',
}
